import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./home.scss";
import httpclient from "../../service/httpclient";
import List from "../../components/lists/list";
import SimpleScrollBar from "../../components/ScrollBar/SimpleScrollBar";
import NavigationBar from "../../components/NavigationBar/navigationbar";
import { NavLink, useLocation } from "react-router-dom";
import {
  CheckCircleOutlined,
  RightOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { Progress, Space, Tooltip } from "antd";
import routeUrls from "../../route/routeurls";
import moment from "moment";
import LotteryPanel from "./lottery/LotteryPanel";
import LotteryPrizeModal from "./lottery/LotteryPrizeModal";
import LotterySharePosterModal from "./lottery/LotterySharePosterModal";
import { getLotteryRewardIcon } from "./lottery/lottery-utils";
import useLotterySharePoster from "./lottery/useLotterySharePoster";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function getLotteryPrizeIndex(rewards, prize) {
  if (!prize || !rewards.length) return 0;

  const idMatchedIndex = rewards.findIndex(
    (reward) => String(reward.id) === String(prize.id)
  );
  if (idMatchedIndex >= 0) return idMatchedIndex;

  const nameMatchedIndex = rewards.findIndex(
    (reward) =>
      reward.type === prize.type &&
      String(reward.name || reward.label) === String(prize.name || prize.label)
  );
  return Math.max(nameMatchedIndex, 0);
}

function getLotterySpinDelta(currentRotation, prizeIndex, segmentAngle) {
  const normalizedRotation = ((currentRotation % 360) + 360) % 360;
  const prizeCenterAngle = prizeIndex * segmentAngle + segmentAngle / 2;
  const targetRotation = (360 - prizeCenterAngle) % 360;
  const alignDelta =
    (targetRotation - normalizedRotation + 360) % 360;

  return 360 * 3 + alignDelta;
}

function Home() {
  const [CategoriesData, setCategoriesData] = useState(null);
  const [carouselData, setCarouselData] = useState(null);
  const [childData, setChildData] = useState({});
  const [recommendData, setRecommendData] = useState(null);
  const [learningProgressData, setLearningProgressData] = useState(null);
  const [isPossessCategory6, setIsPossessCategory6] = useState(false); //hardcode 模拟笔试/面试隐藏
  const [lotteryData, setLotteryData] = useState(null);
  const [lotteryChances, setLotteryChances] = useState(0);
  const [lotteryRotation, setLotteryRotation] = useState(0);
  const [lotteryDrawing, setLotteryDrawing] = useState(false);
  const [lotteryPrizeModal, setLotteryPrizeModal] = useState(null);
  const lotterySharePoster = useLotterySharePoster();
  const [lotteryRightsLevel, setLotteryRightsLevel] = useState(null);
  const categoriesid = 1;
  let query = useQuery();
  const authToken = localStorage.token;
  const hasActiveLottery = !!lotteryData?.activity;
  const selectedParam = query.get("selected");
  const selected = hasActiveLottery
    ? selectedParam || "lottery"
    : selectedParam === "discount"
      ? "discount"
      : "early";
  const lotteryRewards = useMemo(() => {
    return (lotteryData?.prizes || []).map((prize) => ({
      ...prize,
      label: prize.label || prize.name,
      icon: getLotteryRewardIcon(prize.icon_key),
    }));
  }, [lotteryData]);
  const lotterySegmentAngle = 360 / Math.max(lotteryRewards.length, 1);
  useEffect(() => {
    if (localStorage.token) {
      httpclient.possessCategory(6, false).then((res) => {
        setIsPossessCategory6(res.result);
      });
    }
  }, [localStorage.token]);
  useEffect(() => {
    httpclient.getCategoriesData(categoriesid).then(async (data) => {
      setCategoriesData(data);
      if (data?.children) {
        const child_data = {};
        for (let child of data.children) {
          if (child.detail.published) {
            await httpclient.getCategoriesData(child.id).then((res) => {
              const temp = [];
              for (let item of res?.children) {
                if (item.detail.published) {
                  const detail = item?.detail;
                  temp.push({
                    id: item.id,
                    image: detail?.image,
                    name: detail?.name,
                    description: detail?.introduction_html,
                    link: routeUrls(item.datatype, item.id),
                    displayable: detail?.displayable,
                  });
                }
              }
              child_data[child.id] = temp;
            });
          }
          setChildData({ ...child_data });
        }
      }
    });
  }, []);
  useEffect(() => {
    httpclient.getCarouselAllData().then((res) => {
      setCarouselData(res);
    });
  }, []);
  useEffect(() => {
    if (localStorage.token) {
      httpclient.getRecommendData().then((res) => {
        if (res && res?.length > 0) setRecommendData(res);
      });
      httpclient.getLearningProgress().then((data) => {
        if (data && data.length !== 0) setLearningProgressData(data);
      });
    }
  }, [localStorage.token]);
  useEffect(() => {
    httpclient.getLotteryCurrent().then((data) => {
      setLotteryData(data);
      setLotteryChances(data?.chance?.remaining || 0);
    });
  }, [authToken]);
  useEffect(() => {
    if (authToken) {
      httpclient.getUserRightsData().then((data) => {
        setLotteryRightsLevel(data?.level || null);
      });
    } else {
      setLotteryRightsLevel(null);
    }
  }, [authToken]);
  const handleClick = (e, disable) => {
    if (disable) {
      e.preventDefault(); // 阻止跳转
    }
  };
  const handleLotteryDraw = useCallback(async () => {
    if (!authToken) {
      const redirectUrl =
        window.location.pathname + window.location.search + window.location.hash;
      window.loginRedirectUrl = redirectUrl;
      sessionStorage.setItem("loginRedirectUrl", redirectUrl);
      window.location.href = "/user/login";
      return;
    }

    if (lotteryDrawing || lotteryChances <= 0) return;
    setLotteryDrawing(true);
    try {
      const result = await httpclient.drawLottery();
      const prize = result?.prize;
      const prizeIndex = getLotteryPrizeIndex(lotteryRewards, prize);
      const modalPrize = {
        ...prize,
        label: prize?.label || prize?.name,
        icon: getLotteryRewardIcon(prize?.icon_key),
        grant: result?.grant,
        record_id: result?.record_id,
      };

      setLotteryRotation(
        (prev) =>
          prev + getLotterySpinDelta(prev, prizeIndex, lotterySegmentAngle)
      );
      window.setTimeout(() => {
        setLotteryChances(result?.chance?.remaining || 0);
        setLotteryData((prev) =>
          prev ? { ...prev, chance: result?.chance || prev.chance } : prev
        );
        setLotteryDrawing(false);
        setLotteryPrizeModal(modalPrize);
      }, 4000);
    } catch (e) {
      setLotteryDrawing(false);
    }
  }, [
    authToken,
    lotteryChances,
    lotteryDrawing,
    lotteryRewards,
    lotterySegmentAngle,
  ]);

  const handleLotteryContinueDraw = useCallback(() => {
    setLotteryPrizeModal(null);
    if (lotteryChances > 0) {
      window.setTimeout(handleLotteryDraw, 0);
    }
  }, [handleLotteryDraw, lotteryChances]);

  function Description() {
    return (
      <div className="recruitment-question-membership-card-description">
        <div>
          <Space>
            <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
            解锁所有提单
          </Space>
        </div>
        <div>
          <Space>
            <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
            会员模拟考试
          </Space>
        </div>
        <div>
          <Space>
            <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
            秋招新题速达
          </Space>
        </div>
        <div>
          <Space>
            <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
            更多福利...
          </Space>
        </div>
      </div>
    );
  }

  const carouselCard = useMemo(() => {
    if (selected === "lottery" && hasActiveLottery) {
      return (
        <LotteryPanel
          activityEndAt={lotteryData?.activity?.end_at}
          chances={lotteryChances}
          drawing={lotteryDrawing}
          isLoggedIn={!!authToken}
          rewards={lotteryRewards}
          rightsLevel={lotteryRightsLevel}
          rotation={lotteryRotation}
          segmentAngle={lotterySegmentAngle}
          sharePosterLoading={lotterySharePoster.loading}
          onDraw={handleLotteryDraw}
          onOpenSharePoster={lotterySharePoster.open}
        />
      );
    }
    if (selected === "discount") {
      return (
        <div style={{ width: "280px" }}>
          <div className="recruitment-question-membership-card">
            <div className="recruitment-question-membership-card-title">
              <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
            </div>

            <Description />

            <div
              className="recruitment-question-membership-card-button"
              type="primary"
              onClick={() =>
                window.open(
                  "/info/product_membership/1",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <b style={{ fontSize: 16 }}>
                <Space>
                  前往了解
                  <RightOutlined />
                </Space>
              </b>
            </div>
          </div>
        </div>
      );
    }
    return carouselData?.[selected]?.map((item) => (
      <Tooltip
        placement="bottom"
        title={selected !== "notice" ? item.des : null}
        className="carousel-card-item"
      >
        <NavLink
          style={{
            display: "flex",
            cursor: selected === "soon" ? "not-allowed" : "pointer",
          }}
          onClick={(e) => {
            handleClick(e, selected === "soon");
          }}
          to={item.link}
        >
          <div className="carousel-item-left">
            <img className="carousel-item-image" src={item.image} />
            <div className="carousel-item-name">{item.name}</div>
            <div className="carousel-item-des">{item.des}</div>
          </div>
          {selected === "early" && (
            <div className="carousel-item-price">
              <div className="carousel-original-price">
                RMB {item.originalPrice / 100}/年
              </div>
              <div className="carousel-price">RMB {item.price / 100}/年</div>
              <div className="carousel-buy-button">
                <ShoppingCartOutlined /> 购买
              </div>
            </div>
          )}
        </NavLink>
      </Tooltip>
    ));
  }, [
    authToken,
    carouselData,
    handleLotteryDraw,
    hasActiveLottery,
    lotterySharePoster.loading,
    lotterySharePoster.open,
    lotteryChances,
    lotteryData,
    lotteryDrawing,
    lotteryRightsLevel,
    lotteryRewards,
    lotterySegmentAngle,
    lotteryRotation,
    selected,
  ]);
  const categorieslist = useMemo(() => {
    if (CategoriesData) return List(CategoriesData.children);
  }, [CategoriesData]);
  const zhuanlansCard = useMemo(() => {
    return CategoriesData?.children?.map((item) => {
      if (!item?.detail?.published) {
        return;
      }
      let zhuanlans = childData?.[item.id]?.map((child) => {
        if (
          (child.id === 6 && !isPossessCategory6) ||
          (child.id === 57 && isPossessCategory6)
        ) {
          return; //hardcode 隐藏模拟笔试/面试
        }
        if (child.displayable === 0) {
          return (
            <div
              style={{ cursor: "not-allowed" }}
              className="zhuanlan-card-item"
            >
              <img className="zhuanlan-card-image" src={child.image} />
              <div className="zhuanlan-card-name">{child.name}</div>
              <div className="zhuanlan-card-des">{child.description}</div>
              <div className="zhuanlan-card-notice">即将开放...</div>
            </div>
          );
        } else {
          return (
            <NavLink to={child.link} className="zhuanlan-card-item">
              <img className="zhuanlan-card-image" src={child.image} />
              <div className="zhuanlan-card-name">{child.name}</div>
              <div className="zhuanlan-card-des">{child.description}</div>
            </NavLink>
          );
        }
      });
      if(item.id === 43){
        zhuanlans = []
        zhuanlans?.push(
            <NavLink to="/zhuanlans/51" className="zhuanlan-card-item">
              <img className="zhuanlan-card-image" src="https://cdn.datongbei.com/icdesign-1723129690236g684d4cd5ad49.jpg?imageView2/0/format/jpg/q/90|imageslim" />
              <div className="zhuanlan-card-name">SAR ADC</div>
              <div className="zhuanlan-card-des">模拟与数字的桥梁，让我们从SAR ADC开始！</div>
            </NavLink>
        )
        zhuanlans?.push(
            <NavLink to="/zhuanlans/60" className="zhuanlan-card-item">
              <img className="zhuanlan-card-image" src="https://cdn.datongbei.com/icdesign-1751471089333hf5544f0fddaf.png?imageView2/0/format/jpg/q/90|imageslim" />
              <div className="zhuanlan-card-name">Current Steering DAC</div>
              <div className="zhuanlan-card-des">Current Steering DAC，在高速高精度DAC中被广泛采用，如通讯，视频处理等应用场景。 同时，其核心工作原理相对直观，是理解现代DAC设计基础架构的理想起点，本专栏将带领大家深入探究它的奥秘。</div>
            </NavLink>
        )
        zhuanlans?.push(
            <NavLink to="/zhuanlans/50" className="zhuanlan-card-item">
              <img className="zhuanlan-card-image" src="https://cdn.datongbei.com/icdesign-17047983745643c5g5a2h33ae6.png?imageView2/0/format/jpg/q/90|imageslim" />
              <div className="zhuanlan-card-name">CPPLL系统建模入门</div>
              <div className="zhuanlan-card-des">PLL之旅，让我们从CPPLL开始。而CPPLL，让我们从建模开始！</div>
            </NavLink>
        )
      }
      return (
        <div className="list-card-item">
          <div className="list-name">
            <NavLink style={{ color: "#7B7B7B" }} to={`/categories/${item.id}`}>
              {item.detail.name}{" "}
              <span style={{ fontSize: "12px" }}>
                <RightOutlined />
                <RightOutlined />
              </span>
            </NavLink>
          </div>
          <div className="list-content">{zhuanlans}</div>
        </div>
      );
    });
  }, [CategoriesData, childData, isPossessCategory6]);
  const navigationData = [
    ...(hasActiveLottery
      ? [
          {
            title: "每日抽奖",
            link: "/?selected=lottery",
            key: "lottery",
          },
        ]
      : []),
    {
      title: "早鸟价",
      link: "/?selected=early",
      key: "early",
    },
    {
      title: "秋招题库",
      link: "/?selected=discount",
      key: "discount",
    },
    // {
    //   title: "即将上线",
    //   link: "/?selected=soon",
    //   key: "soon",
    // },
    // {
    //   title: "公告信息",
    //   link: "/?selected=notice",
    //   key: "notice",
    // },
  ];
  const learningData = useMemo(() => {
    return learningProgressData?.map((item) => {
      return {
        name: item.zhuanlan_name,
        progress: item.progress,
        link: "/chapters/" + item.chapter_id,
        time: moment(item.updated_at).format("YYYY-MM-DD"),
      };
    });
  }, [learningProgressData]);
  const learningCards = useMemo(() => {
    return learningData?.map((item) => (
      <div className="learning-card-item">
        <NavLink to={item.link}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="learning-card-name">{item.name}</div>
            {/*<div className="learning-card-time">{item.time}</div>*/}
          </div>
          <Progress
            trailColor="white"
            strokeColor="#486889"
            strokeWidth={4}
            percent={item.progress}
          />
        </NavLink>
      </div>
    ));
  }, [learningData]);

  const CountdownTimer = ({ createdAt }) => {
    const createdDate = new Date(createdAt);
    const endDate = new Date(createdDate.getTime() + 7 * 24 * 60 * 60 * 1000); // 加三天
    const [timeRemaining, setTimeRemaining] = useState(endDate - new Date());

    useEffect(() => {
      const interval = setInterval(() => {
        const now = new Date();
        const remaining = endDate - now;

        if (remaining <= 0) {
          clearInterval(interval);
          setTimeRemaining(0);
        } else {
          setTimeRemaining(remaining);
        }
      }, 1000);

      return () => clearInterval(interval);
    }, [endDate]);

    const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    const formatTime = (time) => String(time).padStart(2, "0");
    const formattedTime = `${formatTime(hours)}:${formatTime(
      minutes
    )}:${formatTime(seconds)}`;
    return (
      <div className="countdown-timer">
        {timeRemaining > 0 ? (
          <div>{formattedTime} 后失效</div>
        ) : (
          <div>倒计时结束</div>
        )}
      </div>
    );
  };
  const recommendCards = useMemo(() => {
    return recommendData?.map((item) => {
      return (
        <div className="recommend-card-item">
          <NavLink to={item.link}>
            <div className="recommend-item-name">{item.name}</div>
            <div className="recommend-item-original-price">
              RMB {item.price / 100}/年
            </div>
            <div className="recommend-item-price">
              RMB {item.price / 200}/年
            </div>
            <div className="recommend-item-des">{item.des}</div>
            <div className="recommend-buy-button">
              <ShoppingCartOutlined /> 购买
            </div>
            <CountdownTimer createdAt={item.created_at} />
          </NavLink>
        </div>
      );
    });
  }, [recommendData]);

  const mobileRecommendCards = useMemo(() => {
    return recommendData?.map((item) => {
      return (
        <div className="mobile-recommend-card-item">
          <NavLink to={item.link}>
            <div className="mobile-recommend-item-name">{item.name}</div>
            <div style={{ display: "flex" }}>
              <div className="mobile-recommend-item-original-price">
                RMB {item.price / 100}/年
              </div>
              <div className="mobile-recommend-item-price">
                RMB {item.price / 200}/年
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="mobile-recommend-buy-button">
                <ShoppingCartOutlined /> 购买
              </div>
              <CountdownTimer createdAt={item.created_at} />
            </div>
          </NavLink>
        </div>
      );
    });
  }, [recommendData]);
  return (
    <div className="home">
      <SimpleScrollBar>
        <div className="home-wrapper-pc">
          <div className="home-carousel">
            <div className="home-carousel-nav">
              {NavigationBar(navigationData, selected ? selected : "early")}
              <div
                className={
                  "home-carousel-cards" +
                  (selected === "lottery" ? " home-carousel-lottery" : "")
                }
              >
                {(selected === "lottery" || carouselData) && carouselCard}
              </div>
            </div>
          </div>
          <div className="home-bottom-wrapper">
            <div className="home-zhuanlan-list">{zhuanlansCard}</div>
            {(!!learningProgressData || !!recommendData) && (
              <div className="home-sidebar">
                <SimpleScrollBar>
                  {!!learningProgressData && (
                    <div className="home-sidebar-item">
                      <div className="home-sidebar-title">
                        我正在学
                        <NavLink
                          to="/user/center/general"
                          style={{ float: "right" }}
                        >
                          <RightOutlined style={{ color: "#486889" }} />
                        </NavLink>
                      </div>
                      <div className="home-sidebar-learning">
                        {learningCards}
                      </div>
                    </div>
                  )}
                  {!!recommendData && (
                    <div className="home-sidebar-item">
                      <div className="home-sidebar-title">推荐课程</div>
                      <div className="home-sidebar-recommend">
                        {recommendCards}
                      </div>
                    </div>
                  )}
                </SimpleScrollBar>
              </div>
            )}
          </div>
        </div>
        <div className="home-wrapper-mobile">
          <div
            style={{
              background: "rgba(72, 104, 137, 0.05)",
              textAlign: "left",
            }}
            className="mobile-wrapper"
          >
            <div className="home-carousel">
              <div className="home-carousel-nav">
                {NavigationBar(
                  navigationData,
                  selected ? selected : "early",
                  1
                )}
                <div
                  className={
                    "home-carousel-cards" +
                    (selected === "lottery" ? " home-carousel-lottery" : "")
                  }
                >
                  {(selected === "lottery" || carouselData) && carouselCard}
                </div>
              </div>
            </div>
            {!!recommendData && (
              <div>
                <div className="home-mobile-title">限时优惠课程</div>
                <div className="home-mobile-recommend">
                  {mobileRecommendCards}
                </div>
              </div>
            )}
            <div className="home-zhuanlan-list">{zhuanlansCard}</div>
          </div>
        </div>
      </SimpleScrollBar>
      <LotteryPrizeModal
        prize={lotteryPrizeModal}
        onClose={() => setLotteryPrizeModal(null)}
        onContinueDraw={handleLotteryContinueDraw}
      />
      {!!lotterySharePoster.poster && (
        <LotterySharePosterModal
          posterPreview={lotterySharePoster.posterPreview}
          onClose={lotterySharePoster.close}
          onCopyLink={lotterySharePoster.copyLink}
          onDownload={lotterySharePoster.download}
        />
      )}
    </div>
  );
}

export default Home;
